export function setImageHeightAndWidth(image) {
  const width = image.naturalWidth;
  const height = image.naturalHeight;

  if (image.src.includes('icons')) {
    image.classList.add('w-11', 'h-11');
    image.classList.remove('hidden');
    return;
  }

  if (width >= 100) {
    image.classList.add('w-26');
  }

  if (height >= 144) {
    image.classList.add('h-36');
  }

  image.classList.remove('hidden');
}

document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll('.js-answer-image');

  images.forEach(image => {
    if (image.complete) {
      setImageHeightAndWidth(image);
    } else {
      image.addEventListener('load', function () {
        setImageHeightAndWidth(image);
      });
    }
  });
});
